import { useTheme } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { datePickerSx, slotProps } from './DateInput.style';
import { useState } from 'react';

export const DateInput = ({ formik }) => {
  const theme = useTheme();
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const togglePicker = (e) => {
    e.preventDefault();
    setIsPickerOpen(!isPickerOpen);
  };

  return (
    <DesktopDatePicker
      disableFuture
      open={isPickerOpen}
      label="Date*"
      format="DD/MM/YYYY"
      value={formik.values.date}
      onChange={(value) => {
        formik.setFieldValue('date', value);
        setIsPickerOpen(false);
      }}
      slotProps={slotProps(theme, formik, togglePicker)}
      sx={datePickerSx(theme)}
    />
  );
};
